import {Action, createReducer, on} from '@ngrx/store';
// import {AmbulanceStore} from '../../models/store/user/patient';

// TODO: Add Interfaces

import {editAmbulance, loadAmbulances, paginateAmbulances, removeAllAmbulances, removeAmbulances} from 'src/actions/user/ambulance.action';

export const initialState: any = {
  fetching: false,
  data: {
    ambulances: [],
    totalDocuments: 0
  }
};

const ambulancesReducer = createReducer(initialState,
  on(loadAmbulances, (state, {payload, totalDocuments}) => (
    {
      ...state,
      data: {
        ...state.data,
        ambulances: [
          ...state.data.ambulances,
          ...payload.filter(p => !state.data.ambulances.find((ds: any) => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editAmbulance, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        ambulances: state.data.ambulances.map(
          (data: any) => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeAmbulances, (state, {payload}) => (
    {
      ...state,
      data: {
        ...state.data,
        ambulances: state.data.ambulances
          .filter((d: any) => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllAmbulances, (state) => (
      {
        ...state,
        data: {
          ...state.data,
          ambulances: [],
          totalDocuments: 0
        }
      }
    )
  ),
  on(paginateAmbulances, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return ambulancesReducer(state, action);
}
